module.exports = __webpack_public_path__ + "static/fonts/Helios.dc0a92c.woff";